<template>
  <div class="contentList">
    <div class="list" v-for="item of list" :key="item.time">
      <div class="time">{{ item.time }}</div>
      <div>
        <div class="subList" v-for="sub of item.children" :key="sub.title" @click="goDetail(sub.id, sub.isRead === 1)">
          <div class="title">
            <a-tooltip>
              <template slot="title">
                <div>{{ sub.title }}</div>
              </template>
              <div class="ellipse">{{ sub.title }}</div>
            </a-tooltip>
            <img src="@/assets/icons/icon_j@2x.png" alt="">
            <div class="circle" v-if="sub.isRead === 1"></div>
          </div>
          <div class="desc">{{ sub.desc }}</div>
          <div class="subTime">{{ sub.time }}</div>
        </div>
      </div>
    </div>
    <div class="allRead" @click="readAllButton" v-if="hasUnRead && list.length">
      {{ $t('message.messageList.readAll') }}
    </div>
    <div class="loading" v-if="loading">
      <img src="@/assets/icons/loading.png" alt="">
      <span>{{ $t('message.messageList.loading') }}</span>
    </div>
    <div class="noData" v-else-if="list.length === 0">
      <div>{{ $t('message.messageList.empty.title') }}</div>
      <div v-if="searchData.keyword">{{ $t('message.messageList.empty.searchTip') }}</div>
    </div>
    <div class="end" v-else-if="isEnd">{{ $t('message.messageList.end') }}</div>
  </div>
</template>

<script>
import { feedbackList, messageList, read, readAll } from '@/api/message.js'

export default {
  data() {
    return {
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      list: [],
      loading: false,
      searchData: {}
    }
  },
  props: {
    type: {
      type: String,
      default: 'feedback'
    },
    hasUnRead: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // 监听路由
    $route(to) {
      if (to.name === 'messageIndex') {
        this.resetList()
      }
    }
  },
  methods: {
    // 重置并获取列表
    resetList() {
      this.list = []
      this.pagination.page = 1
      this.getList()
    },
    // 下一页
    next() {
      if (this.isEnd()) return
      this.pagination.page++
      this.getList()
    },
    async getList() {
      this.loading = true
      const data = this.getSearchData()
      if (this.type === 'feedback') {
        const res = await feedbackList(data)
        console.log(res)
        if (res.code === 200) {
          res.data.list.forEach(element => {
            const find = this.list.find(item => item.time === element.createdAt.split(' ')[0])
            const data = {
              title: element.content,
              desc: element.Replies[0].replyContent,
              time: element.Replies[0].createdAt,
              id: element.id,
              isRead: element.isRead
            }
            if (find) {
              find.children.push(data)
            } else {
            this.list.push({
              time: element.createdAt.split(' ')[0],
              children: [data]
            })
            }
          })
          this.pagination.total = res.data.total
        }
      } else {
        const res = await messageList(data)
        if (res.code === 200) {
          res.data.list.forEach(element => {
            const find = this.list.find(item => item.time === element.createdAt.split(' ')[0])
            const resource = element.content.find(item => item.key === 'res_detail')
            const path = element.content.find(item => item.key === 'res_path')
            const data = {
              title: element.title,
              desc: `${resource.name}：${resource.body}。${path.name}：${path.body}`,
              time: element.createdAt,
              id: element.id,
              isRead: element.isRead
            }
            if (find) {
              find.children.push(data)
            } else {
            this.list.push({
              time: element.createdAt.split(' ')[0],
              children: [data]
            })
            }
          })
          this.pagination.total = res.data.total
        }
      }
      this.loading = false
    },
    // 页面显示的实际条数
    pageTotalSize() {
      let num = 0
      this.list.forEach(item => {
        num += item.children.length
      })
      return num
    },
    isEnd() {
      return this.list.length >= 4 && this.pageTotalSize() == this.pagination.total
    },
    getSearchData() {
      let data
      this.$emit('getSearchData', res => {
        this.searchData = res
        data = Object.assign(res, this.pagination)
      })
      return data
    },
    async goDetail(id, isRead) {
      if (isRead) {
        await read({
          id,
          type: this.type
        })
      }
      if (this.type === 'feedback') {
        this.$router.push({ name: 'ideaMessage', query: { id } })
      } else {
        this.$router.push({ name: 'resourceMessage', query: { id } })
      }
    },
    async readAllButton() {
      const res = await readAll({
        type: this.type
      })
      if (res.code === 200) {
        this.resetList()
      }
    }
  },
  mounted () {
    this.getList()
  }
}

</script>

<style scoped lang="less">
.contentList{
  position: relative;
  padding-top: 1px;
}
.ellipse{
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.list{
  padding-top: 22px;
  .time{
    font-weight: 500;
    font-size: 16px;
    color: #6B738C;
  }
  .subList{
    border-bottom: 1px solid #ECECEC;
    padding-bottom: 12px;
    cursor: pointer;
  }
  &:last-child{
    .subList:last-child{
      border-bottom: 0;
    }
  }
  .title{
    margin-top: 22px;
    display: flex;
    align-items: center;
    span{
      font-weight: 600;
      font-size: 14px;
      color: #000000;
    }
    img{
      width: 7px;
      height: 13px;
      margin-left: 8px;
    }
    .circle{
      width: 9px;
      height: 9px;
      background: #FF5700;
      border-radius: 6px;
      margin-left: auto;
    }
  }
  .desc{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-top: 6px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }
  .subTime{
    font-weight: 400;
    font-size: 11px;
    color: #A1A1A1;
    margin-top: 12px;
  }
}
.allRead{
  position: absolute;
  right: 0;
  top: 23px;
  font-weight: 400;
  font-size: 14px;
  color: #6B738C;
  cursor: pointer;
}
.loading{
  display: flex;
  justify-content: center;
  padding-top: 55px;
  img{
    width: 22px;
    height: 22px;
  }
  span{
    font-weight: 500;
    font-size: 14px;
    color: #5F667D;
    margin-left: 12px;
  }
}
.end{
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: #CCCCCC;
  padding-top: 55px;
}
.noData{
  width: 285px;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('~@/assets/img/bj_zanwu.png');
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 15%;
  div:nth-child(1){
    font-weight: 600;
    font-size: 14px;
    color: #0D2340;
    margin-top: 180px;
  }
  div:nth-child(2){
    font-weight: 400;
    font-size: 12px;
    color: #0D2340;
    margin-top: 4px;
  }
}
</style>
